import { render, staticRenderFns } from "./groceries.vue?vue&type=template&id=7fd60bdd&scoped=true"
import script from "./groceries.vue?vue&type=script&lang=js"
export * from "./groceries.vue?vue&type=script&lang=js"
import style0 from "./groceries.vue?vue&type=style&index=0&id=7fd60bdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd60bdd",
  null
  
)

export default component.exports